import { render } from "./RiskDisclosure.vue?vue&type=template&id=5aaeddd6&scoped=true"
import script from "./RiskDisclosure.vue?vue&type=script&lang=js"
export * from "./RiskDisclosure.vue?vue&type=script&lang=js"

import "./RiskDisclosure.vue?vue&type=style&index=0&id=5aaeddd6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aaeddd6"]])

export default __exports__